import React, { useEffect, useState } from "react";
import crmservices from '../../wsclient';
import { useTranslation } from "react-i18next";
import WalletAllowanceView2 from "./WalletAllowanceView2";
import { communityPermisions } from "../../enums/contacts";

export default function WalletAllowanceController2(props) {
    const { t } = useTranslation();
    const { memberSelected, allowances } = props;
    const walletAllowance = allowances ? allowances.wallet_sharing : null;
    const [showProcessing, setShowProcessing] = useState(false);
    const [message, setMessage] = useState(null);
    const [wallet_sharing, setWalletSharing] = useState({
        commerce_pools: null,
        is_enabled: false,
        max_amount: null,
        method: 'AUTO',
        remaining_amount: null,
    });
    const [showCommercePools, setShowCommercePools] = useState(false);
    const [showMaximumAmount, setShowMaximumAmount] = useState(false);
    const [commerce_pools, setCommercePools] = useState([]);
    const [walletSharingEnabled, setWalletSharingEnabled] = useState(false);

    const isFullAccess = false;
    const [defaultValues, setDefaulValues] = useState({
        invitation_method: { label: "EMAIL", value: "EMAIL" },
        access_level: {
            label: isFullAccess ? t('access_level_full') : t('access_level_restricted'),
            value: isFullAccess ? "FULL_ACCESS" : "RESTRICTED_ACCESS"
        },
        restricted_access: {
            contact_management: false,
            service_requests_management: false,
            orders_management: false,
        }
    })

    useEffect(() => {
        if (walletAllowance) {
            if(walletAllowance.commerce_pools && walletAllowance.commerce_pools.length > 0){
                setShowCommercePools(true);
                let _commercePools = [];
                walletAllowance.commerce_pools.forEach(item => {
                    _commercePools.push(item.id);
                });
                setCommercePools(_commercePools)
            }
            let maxAmount = walletAllowance.max_amount ? walletAllowance.max_amount : null;
            if(maxAmount){
                setShowMaximumAmount(true);
            }
            setWalletSharing(prevState => ({
                ...prevState,
                ...walletAllowance,
                max_amount: maxAmount,
            }))
        }

        let _defaultValues = {
            ...defaultValues,
        }
        if (allowances.is_admin) {
            _defaultValues.access_level = { label: t('access_level_full'), value: "FULL_ACCESS" }
        } else {
            if (allowances.permissions && allowances.permissions.length > 0) {
                _defaultValues.access_level = { label: t('access_level_restricted'), value: "RESTRICTED_ACCESS" }
            } else {
                _defaultValues.access_level = { label: t('access_level_restricted'), value: "RESTRICTED_ACCESS" }
            }
        }
        if (allowances.permissions && allowances.permissions.length > 0) {
            let restricted_access = {
                ..._defaultValues.restricted_access
            }
            if (allowances.permissions.includes(communityPermisions.contactPermissions.CONTACT_MANAGEMENT)) {
                restricted_access.contact_management = true;
            }
            if (allowances.permissions.includes(communityPermisions.contactPermissions.SERVICE_REQUESTS_MANAGEMENT)) {
                restricted_access.service_requests_management = true;
            }
            if (allowances.permissions.includes(communityPermisions.contactPermissions.ORDERS_MANAGEMENT)) {
                restricted_access.orders_management = true;
            }
            _defaultValues.restricted_access = restricted_access;
        }
        setDefaulValues(prevState => ({
            ...prevState,
            ..._defaultValues,
        }));


    }, [])


    const toggleWalletAllowance = () => {
        if (wallet_sharing.is_enabled) {
            setWalletSharing(prevState => ({
                ...prevState,
                is_enabled: false,
                max_amount: null,
                commerce_pools: null,
            }))
            setWalletSharingEnabled(true);
            setShowCommercePools(false);
            setShowMaximumAmount(false);
        } else {
            setWalletSharing(prevState => ({
                ...prevState,
                is_enabled: true,
            }));
        }
    }

    const toggleCommercePools = () => {
        setShowCommercePools(!showCommercePools);
    }

    const toggleMaximumAmount = () => {
        setShowMaximumAmount(!showMaximumAmount);
    }

    const onChangeCommercePools = (values) => {
        console.log("AAAA onChangeCommercePools values: ", values);
        setCommercePools(values);
    }

    const onSubmit = async (values) => {
        setShowProcessing(true)

        try {
            let _walletSharing = { ...wallet_sharing };
            let permissions = [];
            let isAdmin = false;

            if (defaultValues.access_level.value === 'RESTRICTED_ACCESS') {
                if (defaultValues.restricted_access.contact_management) {
                    permissions.push(communityPermisions.contactPermissions.CONTACT_MANAGEMENT)
                }
                if (defaultValues.restricted_access.service_requests_management) {
                    permissions.push(communityPermisions.contactPermissions.SERVICE_REQUESTS_MANAGEMENT)
                }
                if (defaultValues.restricted_access.orders_management) {
                    permissions.push(communityPermisions.contactPermissions.ORDERS_MANAGEMENT)
                }
            } else if (defaultValues.access_level.value === 'NO_ACCESS') {
                permissions = [];
            } else {
                isAdmin = true;
            }
            
            
            if(showCommercePools) _walletSharing.commerce_pools = commerce_pools;
            else _walletSharing.commerce_pools = null;
            if(showMaximumAmount) _walletSharing.max_amount = values.max_amount;
            else _walletSharing.max_amount = null;

            let result = await crmservices.communitity.updateCommunityPeople({  
                is_admin: isAdmin,
                permissions: permissions,
                wallet_sharing: _walletSharing
            }, memberSelected.relationship_id);
            if (result.code === 'OK') {
                showMessage({ status: true, message: t('UPDATE_WALLET_ALLOWANCE_SUCCESS'), callBackFn: () => {props.setActive("members")}});
            } else {
                showMessage({ status: true, message: t('UPDATE_WALLET_ALLOWANCE_FAILED') });
            }
        } catch (error) {
            console.log("AAAA onSubmit exception: ", error);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false)
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const onChange = (target, value, label) => {
        setDefaulValues(prevState => ({
            ...prevState,
            [target]: (label ? { [label]: value } : value)
        }));
    }

    return (
        <>
            <WalletAllowanceView2
                message={message}
                showProcessing={showProcessing}
                wallet_sharing={wallet_sharing}
                showCommercePools={showCommercePools}
                showMaximumAmount={showMaximumAmount}
                commerce_pools={commerce_pools}
                isOpen={true}
                walletSharingEnabled={walletSharingEnabled}
                toggleWalletAllowance={toggleWalletAllowance}
                toggleCommercePools={toggleCommercePools}
                toggleMaximumAmount={toggleMaximumAmount}
                onChangeCommercePools={onChangeCommercePools}
                onSubmit={onSubmit}
                readOnly={props.readOnly}
                onChange={onChange}
                defaultValues={defaultValues}
            />
        </>
    )
}